<template>
  <div
    class="transition-all duration-100 md:duration-200"
    ref="target"
    :style="style"
  >
    <div
      :style="wrapperStyle"
      v-show="props.open"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
import { watchEffect, ref } from 'vue'
import { useDynamicPanelWidth, useCommonEventEmitters } from '@/Components/Panels/panel'
import { useScreens } from '@/Composables/screens'

const props = defineProps({
  open: {
    type: Boolean,
    required: true
  },
  location: {
    type: String,
    default: 'left'
  },
  width: {
    type: String,
    default: '300px'
  },
  widths: {
    type: Array,
    default: []
  },
  height: {
    type: String,
    default: '300px'
  }
})

const emits = defineEmits(['clickOutside', 'escPressed'])
const target = ref(null)
useCommonEventEmitters(target, emits)

const { isNarrowScreen } = useScreens()

const verticalLocations = ['top', 'bottom']

const style = ref('')
const wrapperStyle = ref('')

const { panelWidth } = useDynamicPanelWidth(props.width, props.widths)

watchEffect(() => {
  const isVerticalPanel = verticalLocations.includes(props.location)
  const rule = isVerticalPanel ? 'height' : 'width'
  const lengthValue = isVerticalPanel ? props.height : panelWidth.value
  const value = props.open ? lengthValue : 0

  style.value = `${rule}: ${value};`
  wrapperStyle.value = `${rule}: ${lengthValue};`

  if (!isVerticalPanel && isNarrowScreen.value) {
    style.value = `${style.value} position: fixed; top: 0; bottom:0; right: 0; z-index: 1000;`
  }
})
</script>
